/** Remove trailing slashes; keep "/" for root. O(n), no regex. */
export function stripTrailingSlashes(pathname) {
  if (!pathname || pathname === "/") return "/";
  let end = pathname.length;
  while (end > 1 && pathname[end - 1] === "/") {
    end -= 1;
  }
  return pathname.slice(0, end) || "/";
}

export function hasTrailingSlash(pathname) {
  return pathname.length > 1 && pathname.endsWith("/");
}
